module.exports = __webpack_public_path__ + "img/1.5e2e7c57.png";